
import React, { useCallback, useEffect, useState } from 'react';

import styles from './styles.module.scss'
import Commercial1 from '../../public/assets/images/commercials/commercial-01.jpg';
import Commercial2 from '../../public/assets/images/commercials/commercial-02.jpg';
import Commercial3 from '../../public/assets/images/commercials/commercial-03.jpg';
import useMobile from '../Hooks/Mobile';

const content = [
  {
    image: Commercial1.src,
    header: "Workplace Charging",
    text: "More and more employees would like to charge at work. We can help design the best solution."
  },
  {
    image: Commercial2.src,
    header: "Destination Charging",
    text: "Offering charging for your customers or members is a great USP and helps you stand out from the competition."
  },
  {
    image: Commercial3.src,
    header: "Apartment Charging",
    text: "Tenants are asking about charging their EVs, we have the knowledge and expertise to help manage their expectations while also maximizing the return on investment."
  },
]

export default function CommercialCharges()  {
  const [slide, setSlide] = useState(0)
  
  const tablet = useMobile(980);

  const handleNextSlide = useCallback(() => {
    if (slide < content.length - 1) {
      setSlide(slide + 1)
    }
    else setSlide(0)
  }, [slide])

  // 5 seconds slide animation 
  useEffect(() => {
    if (!tablet) {
      const timeout = setTimeout(handleNextSlide, 5000)
      return () => clearTimeout(timeout)
    }
  }, [handleNextSlide, tablet])

  const openSlide = (index: number) => {
    setSlide(index)
  }
  const renderContent = () => {
    return content.map((item, index) => (
      <div 
        key={index} 
        className={styles.topic + " " + (index === slide && styles.active)}
        onClick={() => openSlide(index)}
      >
        <div className={styles.headerHolder}>
          <div className={styles.numberHolder}>
            <span>0{index + 1}.</span>
          </div>
          
          <h1>{ item.header }</h1>
        </div>
        
        <p>{ item.text }</p>
      </div>
    ))
  }

  const renderContentTablet = () => {
    return content.map((item, index) => (
      <div key={index} className={styles.tabletSlide}>
        <div key={index} className={styles.image} style={{ backgroundImage: `url(${content[index].image})` }}>&nbsp;</div>

        <div 
          key={index} 
          className={styles.topic + " " + styles.active}
          onClick={() => openSlide(index)}
        >
          <div className={styles.headerHolder}>
            <h1>0{index + 1}. { item.header }</h1>
          </div>
          
          <p>{ item.text }</p>
        </div>
      </div>
    ))
  }

  return (
    <div className={styles.commercialCharges}>
      { !tablet && (
        <div key={slide} className={styles.image} style={{ backgroundImage: `url(${content[slide].image})` }}>&nbsp;</div>
      )}

      <div className={styles.contentHolder}>
        { !tablet && renderContent() }

        { tablet && renderContentTablet() }
      </div>
    </div>
  )
};
